import { Stack, Text } from "@fluentui/react";
import { useMemo } from "react";
import {
  tableCellStyle,
  tableContainerStyle,
  tableHeaderCellStyle,
  tableHeaderRowStyle,
  tableStyle,
  tableTitleStyle
} from "../ExploreFeatures.styles";
import { FeatureDataTableProps } from "../ExploreFeatures.interfaces";

export const FeatureDataTable = ({ rawFeatureData, selectedFeatures, showDataTable }: FeatureDataTableProps) => {
  const tableData = useMemo(() => {
    if (!showDataTable || !rawFeatureData.length) return [];

    return rawFeatureData
      .filter((feature) => selectedFeatures.includes(feature.name))
      .flatMap((feature) =>
        feature.data.map((dataPoint) => ({
          featureName: feature.name,
          date: new Date(dataPoint.snapshotDate).toLocaleDateString(),
          value: Number(dataPoint.currentValue).toLocaleString()
        }))
      );
  }, [rawFeatureData, selectedFeatures, showDataTable]);

  if (!tableData.length) return null;

  return (
    <Stack style={tableContainerStyle}>
      <Text variant="medium" style={tableTitleStyle}>
        Tabular View
      </Text>
      <table style={tableStyle}>
        <thead>
          <tr style={tableHeaderRowStyle}>
            <th style={tableHeaderCellStyle}>Feature</th>
            <th style={tableHeaderCellStyle}>Date</th>
            <th style={tableHeaderCellStyle}>Value</th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((row, idx) => (
            <tr key={`${row.featureName}-${idx}`}>
              <td style={tableCellStyle}>{row.featureName}</td>
              <td style={tableCellStyle}>{row.date}</td>
              <td style={tableCellStyle}>{row.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Stack>
  );
};
